import { c as _c } from "react/compiler-runtime";
/* istanbul ignore file */

import type { Entity, HelperResult } from '@openclassrooms/sdk-web';
import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { clientApi } from '../../configuration';
const quizSessionQuestionAnswersMutationKey = ['quiz-session-question-answers'];
const {
  useUpdate
} = getCRUDHooks({
  entityName: 'quizSessionQuestions',
  update: (values: Array<number>, {
    quizSessionQuestionId
  }: {
    quizSessionQuestionId: number;
  }) => clientApi.getOCClient().helpers.assessment.quizSessionQuestions.updateAnswers(quizSessionQuestionId, values) as unknown as HelperResult<Partial<Entity>>
});
const useUpdateQuizSessionQuestionsAnswers = params => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      mutationKey: quizSessionQuestionAnswersMutationKey
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useUpdate(params, t0);
};
export { useUpdateQuizSessionQuestionsAnswers };